import script from "./XLinkExternal.vue?vue&type=script&lang=ts&setup=true"
export * from "./XLinkExternal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__